
import React, { useState, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import SecretarialHeader from '@/components/compliance/secretarial/SecretarialHeader';
import MasterDataTab from '@/components/compliance/secretarial/MasterDataTab';
import FilingsTab from '@/components/compliance/secretarial/FilingsTab';
import DocumentGenerationTab from '@/components/compliance/secretarial/DocumentGenerationTab';
import StatutoryRegistersTab from '@/components/compliance/secretarial/StatutoryRegistersTab';
import ComplianceCalendarTab from '@/components/compliance/secretarial/ComplianceCalendarTab';
import { Skeleton } from "@/components/ui/skeleton";
import LazyLoad from "@/components/LazyLoad";

const TabContentSkeleton = () => (
  <div className="space-y-4 animate-pulse">
    <Skeleton className="h-8 w-1/2 mb-4" />
    <Skeleton className="h-64 w-full mb-4" />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Skeleton className="h-24" />
      <Skeleton className="h-24" />
    </div>
  </div>
);

const SecretarialCompliance = () => {
  const [activeTab, setActiveTab] = useState("masterData");
  const [isLoading, setIsLoading] = useState(true);

  // Optimize with faster initial load
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 50); // Reduced from 100ms to 50ms for more responsive feel
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="space-y-6">
      <SecretarialHeader />

      {isLoading ? (
        <div className="space-y-4">
          <Skeleton className="h-12 w-full max-w-4xl" />
          <TabContentSkeleton />
        </div>
      ) : (
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid grid-cols-5 w-full max-w-4xl">
            <TabsTrigger value="masterData">Master Data</TabsTrigger>
            <TabsTrigger value="filings">Compliances & Filings</TabsTrigger>
            <TabsTrigger value="documents">Document Generation</TabsTrigger>
            <TabsTrigger value="registers">Statutory Registers</TabsTrigger>
            <TabsTrigger value="calendar">Calendar</TabsTrigger>
          </TabsList>

          <TabsContent value="masterData">
            <LazyLoad delay={50}>
              <MasterDataTab />
            </LazyLoad>
          </TabsContent>

          <TabsContent value="filings">
            <LazyLoad delay={100}>
              <FilingsTab />
            </LazyLoad>
          </TabsContent>

          <TabsContent value="documents">
            <LazyLoad delay={150}>
              <DocumentGenerationTab />
            </LazyLoad>
          </TabsContent>

          <TabsContent value="registers">
            <LazyLoad delay={200}>
              <StatutoryRegistersTab />
            </LazyLoad>
          </TabsContent>

          <TabsContent value="calendar">
            <LazyLoad delay={250}>
              <ComplianceCalendarTab />
            </LazyLoad>
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
};

export default SecretarialCompliance;
